import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isPresent } from '@mtna/core-ts';

@Pipe({
  name: 'rdsPctTotal',
})
export class RdsPercentOfTotalPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  transform(count: number | null | undefined, total: number | null | undefined, ...args: (string | number)[]): string {
    if (!isPresent(count) || !isPresent(total)) {
      return '';
    }
    const minFractionDigits: string | number = isPresent(args[0]) ? args[0] : '0';
    const maxFractionDigits: string | number = isPresent(args[1]) ? args[1] : '2';

    const transformedValue = this.decimalPipe.transform((count / total) * 100, `1.${minFractionDigits}-${maxFractionDigits}` || '');
    return `${transformedValue}%`;
  }
}
